import { render, staticRenderFns } from "./InputDetail.vue?vue&type=template&id=294cf10a&scoped=true"
import script from "./InputDetail.vue?vue&type=script&lang=js"
export * from "./InputDetail.vue?vue&type=script&lang=js"
import style0 from "./InputDetail.vue?vue&type=style&index=0&id=294cf10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294cf10a",
  null
  
)

export default component.exports